<div class="wrapper">
	<app-order-content (closeOrderContent)="dismiss()"></app-order-content>
</div>
